/**
 * @module constants
 */

/**
 * Enum for luci panel message type.
 * @readonly
 */
export default {
  DATAPANEL: {
    LOAD: {
      REQUEST: 'datapanel.load.request',
      RESPONSE: 'datapanel.load.response'
    },
    UPDATE: {
      REQUEST: 'datapanel.update.request',
      RESPONSE: 'datapanel.update.response'
    },
    SELECTIMAGE: {
      REQUEST: 'datapanel.selectimage.request',
      CLOSEDRESPONSE: 'datapanel.selectimage.closedresponse'
    }
  },
  LUCI: {
    UPDATED: {
      REQUEST: 'luci.updated.request'
    },
    PREVIEWGENERATED: {
      REQUEST: 'luci.previewgenerated.request'
    },
    SAVED: {
      REQUEST: 'luci.saved.request'
    }
  }
};



// WEBPACK FOOTER //
// ./app/constants/luciPanelMessageTypes.js